module.exports = __webpack_public_path__ + "img/bg-bot.7dd82319.gif";